import React from 'react';
import PropTypes from 'prop-types';

function BuildingSize (props) {
  const property = props.item.getProperty();
  const building = property.getBuilding();
  const size = building.getSizeLabel();

  return (
    <td className='paper col-building-size'>
      <span className='main-param'>
        { size && <div>{ size }</div> }
      </span>
    </td>
  );
}

BuildingSize.propTypes = {
  item: PropTypes.object.isRequired
};

BuildingSize.defaultProps = {};

export default BuildingSize;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/BuildingSize.jsx